import { APP_DEFAULT_PATH } from 'config';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'store';

// ==============================|| AUTH GUARD ||============================== //

const GuestGuard = ({ children }) => {
  const { isLoggedIn } = useSelector(({ auth }) => auth);
  const location = useLocation();
  const from = location.state?.from;

  if (isLoggedIn) {
    return <Navigate to={from ?? APP_DEFAULT_PATH} replace />;
  }

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
